import React, { useState } from "react";
import COR from "../../PicesForPages/officermortgagePage.jpg";

import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
// import ClientReview from "../Client_Review/clientReview";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";
import FreeQuoteForm from "../Form/FreeQuote";

import KishoreKumarVeeragandham from "../../PicesForPages/KishoreKumarVeeragandham.webp";
import LavanyaDonkala from "../../PicesForPages/LavanyaDonkala.webp";
import VideeshVeeragandham from "../../PicesForPages/VideeshVeeragandham.webp";

import blankPhoto from "../../PicesForPages/blank.jpg";

import { useParams } from "react-router-dom";

function TeamMemberFullDetails() {
  const { id } = useParams();

  // Initialize the state before any condition
  const [isFreeQuoteVisible, setIsFreeQuoteVisible] = useState(false);

  const teamMembers = {
    "kishorekumar-veeragandham": {
      name: "Kishore Kumar Veeragandham",
      role: "Sr. Mortgage Loan Originator",
      photo: KishoreKumarVeeragandham,
      nmls: "2212174",
      licensed: "FL, OH & TX",
      address: "5714 Dorrington St,\nLewis Center OH 43035",
      contactPhone: "(614) 397-1676",
      contactMail: "kishore@vidhimortgage.com",
      yourService: `Whether you’re purchasing a home, refinancing, or building your dream property, choosing the right loan professional is essential. With constantly changing market conditions and mortgage programs, it’s important to work with someone who can provide timely, accurate guidance. As an experienced loan officer, I’m here to help you navigate your options and find the financing solution that best fits your needs.\n\nMy goal is to ensure you make confident, informed decisions for yourself and your family. I am dedicated to delivering a smooth and personalized mortgage experience that goes beyond expectations.\n\nFeel free to explore the available loan programs, use the tools and calculators, and complete the secure online application to get started. Once your application is submitted, I will reach out to review your options and next steps. You can also schedule an appointment at your convenience.\n\nIf you have any questions, I’m always available by phone or email to provide expert guidance and support.\n\nI look forward to working with you.
`,
    },
    "lavanya-donkala": {
      name: "Lavanya Donkala",
      role: "Mortgage Loan Originator",
      photo: LavanyaDonkala,
      nmls: "2594203",
      licensed: "OH",
      address: "5714 Dorrington St,\nLewis Center OH 43035",
      contactPhone: "(614) 956-9005",
      contactMail: "lavanya@vidhimortgage.com",
      yourService: `Whether you’re purchasing a home, refinancing, or building your dream property, choosing the right loan professional is essential. With constantly changing market conditions and mortgage programs, it’s important to work with someone who can provide timely, accurate guidance. As an experienced loan officer, I’m here to help you navigate your options and find the financing solution that best fits your needs.\n\nMy goal is to ensure you make confident, informed decisions for yourself and your family. I am dedicated to delivering a smooth and personalized mortgage experience that goes beyond expectations.\n\nFeel free to explore the available loan programs, use the tools and calculators, and complete the secure online application to get started. Once your application is submitted, I will reach out to review your options and next steps. You can also schedule an appointment at your convenience.\n\nIf you have any questions, I’m always available by phone or email to provide expert guidance and support.\n\nI look forward to working with you.
`,
    },
    "videesh-veeragandham": {
      name: "Videesh Veeragandham",
      role: "Mortgage Loan Originator",
      photo: VideeshVeeragandham,
      nmls: "2832629",
      licensed: "OH",
      address: "5714 Dorrington St,\nLewis Center OH 43035",
      contactPhone: "(614) 330-3517",
      contactMail: "videesh@vidhimortgage.com",
      yourService: `Whether you’re purchasing a home, refinancing, or building your dream property, choosing the right loan professional is essential. With constantly changing market conditions and mortgage programs, it’s important to work with someone who can provide timely, accurate guidance. As an experienced loan officer, I’m here to help you navigate your options and find the financing solution that best fits your needs.\n\nMy goal is to ensure you make confident, informed decisions for yourself and your family. I am dedicated to delivering a smooth and personalized mortgage experience that goes beyond expectations.\n\nFeel free to explore the available loan programs, use the tools and calculators, and complete the secure online application to get started. Once your application is submitted, I will reach out to review your options and next steps. You can also schedule an appointment at your convenience.\n\nIf you have any questions, I’m always available by phone or email to provide expert guidance and support.\n\nI look forward to working with you.
`,
    },

    "#": {
      name: "Coming Soon",
      role: "---- ---------",
      photo: blankPhoto,
      nmls: "-------",
      address: "5714 Dorrington St,\nLewis Center OH 43035",
      contactPhone: "(111) 342-5726",
      contactMail: "jane.doe@vidhimtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
  };

  const member = teamMembers[id];

  if (!member) {
    return <div>Team Member not found</div>;
  }

  // Function to hide the FreeQuoteFormParent
  const hideFreeQuoteForm = () => {
    setIsFreeQuoteVisible(false);
  };

  // Function to handle clicks outside the FreeQuoteBox
  const handleOutsideClick = (event) => {
    if (event.target.classList.contains("FreeQuoteFormParent")) {
      hideFreeQuoteForm();
    }
  };
  return (
    <div className="purchaseParent ourTeamMemberParent">
      <div className="ourTeamMemberTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="ourTeamMemberTopBGImage"
        />
        <div className="ourTeamMemberTopBox">
          <span className="ourTeamMemberTopLeftSide">
            <span className="ourTeamMemberTopLeftSideSpanImage">
              <img
                fetchPriority="high"
                loading="eager"
                src={member.photo}
                alt={member.name}
                className="ourTeamMemberTopStaffImage"
              />
            </span>
            <span>
              <span className="ourTeamMemberTopLeftSideName">
                {member.name}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideRole">
                {member.role}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideRole">
                Licensed: {member.licensed}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideNMLS">
                NMLS#: {member.nmls}
              </span>
              <br />
            </span>
          </span>
          <span className="ourTeamMemberTopRightSide">
            <span>
              <b>Address:</b>
              <br />
              {member.address.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
            <br />
            <span>
              <b>Contact:</b>
              <br />
              <i className="ri-phone-fill"></i> {member.contactPhone}
              <br />
              <i className="ri-mail-send-fill"></i> {member.contactMail}
              <br />
            </span>
          </span>
        </div>
      </div>
      <div className="purchaseBottomParent ourTeamMemberBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <div className="purchaseBottomLeftButton">
              <a
                // href={`https://vidhimortgage.my1003app.com/${member.nmls}`}
                href={"https://vidhimortgage.my1003app.com/" + member.nmls}
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
              <span
                className="purchaseBottomLeftButtonLink00"
                onClick={(e) => {
                  e.preventDefault();
                  setIsFreeQuoteVisible(true);
                }}
              >
                Free Quote
              </span>
            </div>

            <span className="purchaseBottomLeftHeader">At Your Service</span>

            <span className="purchaseBottomLeftContent">
              {member.yourService.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
      </div>
      {/* <ClientReview /> */}
      <MortgageCalculator />

      <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            <span className="brand_text">VIDHI MORTGAGE LLC</span> Location
            Details
          </div>
          <div className="addressMapDetails">
            <iframe
              title="Vidhi Mortgage Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.083140541334!2d-83.0162237!3d40.2072135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838f11646f69bef%3A0x58adb357891a0cfa!2s5714%20Dorrington%20St%2C%20Lewis%20Center%2C%20OH%2043035%2C%20USA!5e0!3m2!1sen!2sin!4v1774413767335!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <BlogPostInAPage />

      {isFreeQuoteVisible && (
        <div className="FreeQuoteFormParent" onClick={handleOutsideClick}>
          <div className="FreeQuoteFormBox">
            <FreeQuoteForm officerName={`${member.name} ${member.nmls}`} />
            <span
              className="FreeQuoteFormCloseButton"
              onClick={hideFreeQuoteForm}
            >
              <span>X</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeamMemberFullDetails;
